'use client';

import {useEffect} from 'react';
import {MegaNavABTest} from '~/common/components/MegaNav/MegaNavABTest';

/** *
 *
 * This wrapper component allows for the MegaNav to be added into specific pages
 * of apps that wouldn't normally include the MegaNav, such as the Fabric Create Flow's Confirmation page.
 *
 * It requires that the app's index.html file include this:
 *  {% include 'nav.html' %}
 *
 *  ** */

export const InjectableMegaNav = () => {
  useEffect(() => {
    document.getElementById('pbMegaNav')?.classList.remove('hidden');
    document.getElementById('meganav-variant-global-nav')?.classList.remove('hidden');
    document.getElementById('meganav-variant-local-nav')?.classList.remove('hidden');

    return () => {
      document.getElementById('pbMegaNav')?.classList.add('hidden');
      document.getElementById('meganav-variant-global-nav')?.classList.add('hidden');
      document.getElementById('meganav-variant-local-nav')?.classList.add('hidden');
    };
  }, []);

  return (
    <>
      <div className="injectable-header">
        <MegaNavABTest />
      </div>
      <div id="fixed-header-spacer" />
    </>
  );
};
